import { queryLngLat } from '@/lib/queryRemoteTiles';
const QUERYZOOM = 15;
// Bump when DTA tiles change and CloudFront invalidation is insufficient (QA).
const TILE_CACHE_VERSION = '20260908';

async function getBoundaryForPoint(stage, lngLatStr) {
    const lngLat = lngLatStr.map((x) => +x);

    const tilesetId = `dta`; // don't use stage

    const result = await queryLngLat(
        `${window.app.tileHost}/tiles/${tilesetId}/{z}/{x}/{y}.pbf?v=${TILE_CACHE_VERSION}`,
        lngLat,
        QUERYZOOM,
        'dta',
        { quiet: false }
    );
    if (result && result.features) {
        return result.features.map((f) => f.properties);
    } else {
        console.log(`No boundary for dta ${lngLat}`);
    }
}

export { getBoundaryForPoint };
